import React from 'react';
import PropTypes from 'prop-types';
import types from '../../types';
import styles from './styles.module.scss';

const ModalHeader = ({children, onClick}) => (
    <div className={styles.modalHeaderContainer}>
      <div className={styles.arrow} onClick={onClick}/>
      <div className={styles.label}>
        {children}
      </div>
    </div>
);

ModalHeader.propTypes = {
  ...types.children,
  onClick: PropTypes.func
};

export default ModalHeader;
